
import * as cookies from 'browser-cookies'
import config from './config'

/**
 * Cookie name for auth.
 */

const cookieName = 'apex_auth'

/**
 * get the auth token from cookie.
 */

export function get() {
  return cookies.get(cookieName)
}

/**
 * set the auth token cookie.
 */

export function set(token) {
  cookies.set(cookieName, token, config.cookie)
}

/**
 * remove the auth token cookie.
 */

export function remove() {
  cookies.erase(cookieName, config.cookie)
}

/**
 * Parse token into a user object.
 */

export function parse(token) {
  const [signature, payload] = token.split('.')
  const user = JSON.parse(atob(payload))
  return { token, ...user }
}
